import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import axios from "axios";
import { fmtCurrency, fmtDate, fmtPhone, fmtNumber } from "../utils/countryFormat";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_STATE = {
  country_code: "VE",
  currency_code: "VES",
  timezone: "America/Caracas",
  preset: null,
};

const CountryContext = createContext({
  ...DEFAULT_STATE,
  ready: false,
  fmtCurrency: (v, cur) => fmtCurrency(v, null, cur),
  fmtNumber: (v, opts) => fmtNumber(v, null, opts),
  fmtDate: (v, mode) => fmtDate(v, null, mode),
  fmtPhone: (v) => fmtPhone(v, null),
  reload: () => {},
});

export function CountryProvider({ children }) {
  const [state, setState] = useState({ ...DEFAULT_STATE, ready: false });

  const load = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) { setState(s => ({ ...s, ready: true })); return; }
      const res = await axios.get(`${API}/my/country-preset`);
      setState({
        country_code: res.data.country_code,
        currency_code: res.data.currency_code,
        timezone: res.data.timezone,
        preset: res.data.preset,
        ready: true,
      });
    } catch (_e) {
      setState(s => ({ ...s, ready: true }));
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = useMemo(() => ({
    ...state,
    is_ve: (state.country_code || "VE") === "VE",
    reload: load,
    fmtCurrency: (v, override) => fmtCurrency(v, state.preset, override),
    fmtNumber: (v, opts) => fmtNumber(v, state.preset, opts),
    fmtDate: (v, mode) => fmtDate(v, state.preset, mode),
    fmtPhone: (v) => fmtPhone(v, state.preset),
  }), [state, load]);

  return <CountryContext.Provider value={value}>{children}</CountryContext.Provider>;
}

export const useCountry = () => useContext(CountryContext);
